<template>
  <div class="tank-box">
    <h2 class="title">
      タンク情報
    </h2>
    <v-layout
      v-for="(item, i) in [...tanks, {no: -1}]"
      :key="item.no"
      align-center
      py-1
      pl-3
      pr-1
      class="tank-box-in"
    >
      <template
        v-if="item.no < 0"
      >
        <v-flex
          xs12
          class="text-xs-center addition-row"
          @click="$emit('add-tank')"
        >
          <v-icon
            color="green"
          >
            mdi-plus
          </v-icon>
        </v-flex>
      </template>
      <template
        v-else
      >
        <v-flex pl-3>
          {{ item.no }}
        </v-flex>
        <v-flex xs4>
          <TankTypeSelect
            v-model="item.tankType"
            @input="setMaxVolume($event, i)"
          />
        </v-flex>
        <v-spacer />
        <v-flex xs2>
          <NumberField
            v-model="item.volumeThreshold"
            label="しきい値"
            suffix="L"
            class="purple-input"
            :max="tankMaxVolumes[i]"
            :rules="['required']"
          />
        </v-flex>
        <v-spacer />
        <v-flex xs2>
          <NumberField
            v-model="item.deliveryFrequency"
            label="頻度"
            class="purple-input"
            suffix="日に一回"
            :rules="['required', 'above1']"
          />
        </v-flex>
        <v-flex
          xs1
          class="text-xs-center"
          style="cursor: pointer;"
          @click="$emit('remove-tank', item.no)"
        >
          <v-icon
            v-if="item.no !== 1"
            class="close-icon"
            color="red"
          >
            mdi-close
          </v-icon>
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { NumberField, TankTypeSelect } from '@/components/input'
export default {
  components: {
    NumberField,
    TankTypeSelect
  },
  props: {
    tanks: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      tankMaxVolumes: [null]
    }
  },
  computed: {
    ...mapState('tankTypes', ['tankTypes'])
  },
  methods: {
    setMaxVolume (id, i) {
      const tankType = this.tankTypes.find(tt => tt.id === id)
      const maxVolume = tankType
        ? tankType.tankMaxVolume
        : null
      this.tankMaxVolumes[i] = maxVolume

      const threshold = this.tanks[i].volumeThreshold
      this.tanks[i].volumeThreshold = threshold !== null
        ? Math.min(threshold, maxVolume)
        : null
    }
  }
}
</script>

<style lang="scss" scoped>

.tank-box {
  position: relative;
  margin: 10px auto;
  padding: 10px;
  width: 94%;
  background: radial-gradient(var(--metal-blue), transparent);

  &-in {
    background-color: white;

    &:not(:last-of-type) {
      border-bottom: 1px solid transparent;
    }
  }
}

.addition-row {
  transition: background-color .2s;

  &:hover {
  background-color: rgba(63, 111, 182, 0.05);
  cursor: pointer;
  }
}

/deep/.v-text-field__suffix {
  font-size: 0.8rem;
  line-height: 1;
  color: var(--metal-grey);
  padding-right: 10px;
}
</style>
